export default __webpack_public_path__ + "static/media/Logo-full.ade1b81d.svg";